import { getFullAccessActionName } from 'widget/ui-selectors/video-access';

import getTranslationData from './translation-data';
import getCallbackFromProps from './callback';


export default function getPaidAccessButtonConfig(props) {
  const { channelData, videoItem, currentSiteUser } = props;
  const fullAccessAction = getFullAccessActionName(channelData, videoItem, currentSiteUser);

  const callback = getCallbackFromProps(props, fullAccessAction);
  const translationData = getTranslationData(fullAccessAction, channelData, videoItem);

  if (callback && translationData) {
    return {
      callback,
      translationData,
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/paid-access/button-config.js